export default __webpack_public_path__ + "static/18-3b64603af130d7d10a5c2b7998b1fc8f.jpg";